import type {ComponentProps} from 'react';
import React from 'react';
import debounce from 'lodash/debounce';
import {SearchInput} from '@albert-io/atomic';

interface Props extends Omit<ComponentProps<typeof SearchInput>, 'onChange' | 'ref'> {
  /** Invoked with the debounced search string, not the change event. */
  onChange: (searchString: string) => void;
}

export class KeywordSearch extends React.Component<Props> {
  handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    this.debouncedHandleChange(e.target.value);

  debouncedHandleChange = debounce(
    (searchString: string) => this.props.onChange(searchString),
    750
  );

  render() {
    const {onChange, ...rest} = this.props;

    return (
      <SearchInput
        {...rest}
        data-testid='advanced-search__search-input'
        onChange={this.handleChange}
      />
    );
  }
}
